/**
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business Spec Console フロントエンドのランタイム設定。API 接続先を起動時に検証する。
 * @graph-connects none
 */

type SpecConsoleImportMetaEnv = ImportMetaEnv & {
  readonly VITE_API_URL?: string;
};

/** @graph-connects none */
const env = import.meta.env as SpecConsoleImportMetaEnv;

/**
 * API 接続先を解決する。
 *
 * 未設定時に同一オリジンへ落とすと、ビルド設定のドリフトが「API の無いオリジンを叩き続ける」
 * 実行時の機能不全に化けて、原因がビルド設定だと分からなくなる。security.md「必須設定と
 * フォールバック禁止」に従い、境界で落とす。
 *
 * ローカル開発は Vite proxy 経由で叩くため `.env.development` が `/api` を与える。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business API 接続先を起動時に検証し、未設定ならビルド / 起動を失敗させる。
 * @graph-connects none
 */
export function getApiBaseUrl(): string {
  const apiUrl = env.VITE_API_URL;
  if (!apiUrl) {
    throw new Error(
      'VITE_API_URL is not set. Spec Console requires an explicit API origin at build time.',
    );
  }
  return apiUrl;
}

/**
 * 仕様グラフは日次の取り込みジョブでしか更新されないため、他コンソールより
 * キャッシュを長く持たせて再取得を減らす。
 * @graph-connects getApiBaseUrl [calls] API 接続先の検証付き取得
 */
export const config = {
  apiUrl: getApiBaseUrl(),
  query: {
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
  },
} as const;
